import React from "react";
import { useTradesReportDownloader } from "../../../../data/reports/securityCommission/monthlyTrade/hooks/useTradesReportDownloader";
import { useMonthlySecurityExcelDownloader } from "../../../../data/reports/securityCommission/monthlyTrade/hooks/useTradesReportExcelDownloader";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import ExcelIcon from "@material-ui/icons/TableChartOutlined";
import { IconButton } from "@material-ui/core";
import { CustomTooltip } from "../../../components/common/CustomTooltip";

export const DownloadButton: React.FunctionComponent = () => {
	const [downloader, fetchState] = useTradesReportDownloader();
	return (
		<CustomTooltip titleKeyword="exportPDFTooltip">
			<IconButton
				color="secondary"
				component="span"
				onClick={downloader}
				disabled={fetchState.type !== "not-started"}
			>
				<DownloadIcon />
			</IconButton>
		</CustomTooltip>
	);
};

export const DownloadExcelButton: React.FunctionComponent = () => {
	const [downloader, fetchState] = useMonthlySecurityExcelDownloader();
	return (
	  <CustomTooltip titleKeyword="exportXLSXTooltip">
		<IconButton
		  color="secondary"
		  component="span"
		  onClick={downloader}
		  disabled={fetchState.type !== "not-started"}
		>
		  <ExcelIcon />
		</IconButton>
	  </CustomTooltip>
	);
  };
  